module.exports = __webpack_public_path__ + "img/icom8.63c92ecc.png";